import Vue from 'vue'
import AMap from 'vue-amap';
import App from './App.vue'
import router from './router'
import store from './store'
// import  './components/elementUI'
import '@/style/common.css' // global css
// import Cookies from 'js-cookie'

import modal from './utils/modal'


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'

// vant 组件引入
import Vant from 'vant';
import 'vant/lib/index.css';
import VueCanvasPoster from 'vue-canvas-poster';
import './utils/wxShare';
// 分页组件
import Pagination from "@/components/Pagination"
// 自定义表格工具组件
import RightToolbar from "@/components/RightToolbar"
// 图片上传组件
import ImageUpload from "@/components/ImageUpload"
// 图片预览组件
import ImagePreview from "@/components/ImagePreview"

Vue.use(Vant);

Vue.component('Pagination', Pagination)
Vue.component('RightToolbar', RightToolbar)

Vue.use(Vant);
Vue.use(AMap);
Vue.config.productionTip = false
Vue.use(VueCanvasPoster)
Vue.component('ImageUpload', ImageUpload)
Vue.component('ImagePreview', ImagePreview)
Vue.use(ElementUI);
Vue.prototype.$modal = modal
Vue.prototype.$host = '/baidu'
// 初始化vue-amap
AMap.initAMapApiLoader({
  // 高德key
  key: '8859b8e7a76bd03f160f3a208cfe9b1e',
  // 插件集合 （插件按需引入）
  plugin: ['AMap.Geolocation']
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')